import React from "react";
import Form from "rc-field-form";
import { SimpleCheckbox } from "../../../../../components/Fields/SimpleCheckbox";

interface SubFieldProps {
    label: string;
    name: string[];
}

export function SubField({ label, name }: SubFieldProps) {
    return (
        <div>
            <Form.Field name={name} initialValue="1">
                <SimpleCheckbox>{label}</SimpleCheckbox>
            </Form.Field>
        </div>
    );
}
